"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Class Service Display contain API related to service display info
 * @public
 */
class ServiceDisplay extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * API to get service display info
     * @param {string} serviceId
     * @returns
     */
    async getServiceDisplay(serviceId) {
        try {
            const res = await this._apiV2.serviceManagementAPI.getServiceDisplay(serviceId);
            return res;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update service display Info
     * @param {string} serviceId - service ID
     * @param {UpdateServiceDisplayPayload} updateParam - param to update
     * @returns
     */
    async updateServiceDisplay(serviceId, updateParam) {
        try {
            const res = await this._apiV2.serviceManagementAPI.updateDisplayInfo(serviceId, updateParam);
            return res;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ServiceDisplay;
